module.exports = __webpack_public_path__ + "img/authen_zhekou.346dddc8.png";